import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'de',
  months: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthsShort: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'],
  weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  weekdaysMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd, D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D. MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd, D. MMM YYYY HH:mm',
    'llll-Y': 'ddd, D. MMM HH:mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'vor %s Jahr', other: 'vor %s Jahren' },
    M: { one: 'vor %s Monat', other: 'vor %s Monaten' },
    w: { one: 'vor %s Woche', other: 'vor %s Wochen' },
    d: { one: 'vor %s Tag', other: 'vor %s Tagen' },
    h: { one: 'vor %s Std.', other: 'vor %s Std.' },
    m: { one: 'vor %s Min.', other: 'vor %s Min.' },
    s: { one: 'vor %s Sek.', other: 'vor %s Sek.' },
  },
  future: {
    y: { one: 'in %s Jahr', other: 'in %s Jahren' },
    M: { one: 'in %s Monat', other: 'in %s Monaten' },
    w: { one: 'in %s Woche', other: 'in %s Wochen' },
    d: { one: 'in %s Tag', other: 'in %s Tagen' },
    h: { one: 'in %s Std.', other: 'in %s Std.' },
    m: { one: 'in %s Min.', other: 'in %s Min.' },
    s: { one: 'in %s Sek.', other: 'in %s Sek.' },
  },
  abbr: {
    y: { one: '%s J.', other: '%s J.' },
    M: { one: '%s M.', other: '%s M.' },
    w: { one: '%s W.', other: '%s W.' },
    d: { one: '%s T.', other: '%s T.' },
    h: { one: '%s Std.', other: '%s Std.' },
    m: { one: '%s Min.', other: '%s Min.' },
    s: { one: '%s Sek.', other: '%s Sek.' },
  },
  justNow: 'Gerade eben',
  yesterday: 'Gestern',
  today: 'Heute',
  tomorrow: 'Morgen',
  weekStart: 1,
};
const localeName: LocaleName = 'de';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
